export const UPDATE_CHECKOUT_COMPLETE_REQUEST = 'UPDATE_CHECKOUT_COMPLETE_REQUEST';
export const UPDATE_CHECKOUT_COMPLETE_SUCCEEDED = 'UPDATE_CHECKOUT_COMPLETE_SUCCEEDED';
export const UPDATE_CHECKOUT_COMPLETE_FAILED = 'UPDATE_CHECKOUT_COMPLETE_FAILED';
